// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"248":"automobile","594":"about","622":"industrial","790":"quality-control","853":"greases"}[chunkId] + "." + {"248":"5687b81e","594":"33cd0568","622":"f536ce9f","790":"41adc5d7","853":"dea95611"}[chunkId] + ".css";
};